import fillProductKey from './middlewares/fillProductKey'
import populate from './middlewares/populate'
import productsF from './ui/productsF'

module.exports = {
  model: 'products',
  name: 'F-贈品資料',
  ui: productsF,
  middlewares: [populate, fillProductKey],
}



// WEBPACK FOOTER //
// ./src/views/productsF.js